import React from 'react';
import PropTypes from 'prop-types';
export const CheckForError = ({ error, message }) => {
  if (error) {
    return (
      <div>
        <p className={"help-block inline-help text-danger text-left"}>{message}</p>
      </div>
    );
  }
  return null;
};
